module.exports = __webpack_public_path__ + "static/sinteritNILS-6a2c34834cb43a1748be72391cfd2ca7.png";